<template>
  <div class="toggle">
    <toggle
      :value="getValue"
      :checked="value && 'checked'"
      :input-value="getValue"
      :disabled="disabled"
      ref="input"
      :rules="validationRules"
      @change="[setConfigValue($event)]"
    >
      <template
        v-if="!hideTooltip && (!!tooltip || !!helpContent)"
        #append-label
      >
        <tooltip v-if="tooltip" :text="tooltip" />
        <helpIcon v-if="helpContent" :content="helpContent" />
      </template>
    </toggle>
  </div>
</template>

<script>
import toggle from "@/qux-common/qux22/components/molecules/toggle";
import getValidationRules from "@/util/getValidationRules";
import tooltip from "@/components/tooltip";
import helpIcon from "@/components/help-icon";

export default {
  name: "ToggleField",
  components: { toggle, tooltip, helpIcon },
  props: {
    category: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    helpContent: {
      type: String,
    },
    hideTooltip: {
      type: Boolean,
    },
    id: {
      type: String,
    },
    label: {
      type: String,
    },
    parentField: {
      type: String,
    },
    rules: {
      type: Array,
    },
    tooltip: {
      type: String,
    },
    value: {
      type: [Boolean, String],
    },
  },
  methods: {
    /**
     * Sets the value
     */
    setConfigValue(value) {
      this.$emit("setConfigValue", !!value);
    },
    validate() {
      return this.$refs.input.validate();
    },
  },
  computed: {
    getValue() {
      return this.value === true || this.value === "true";
    },
    validationRules() {
      return getValidationRules({
        rules: this.rules,
      });
    },
  },
};
</script>

<style scoped>
</style>